// extracted by mini-css-extract-plugin
module.exports = {"select":"template_select__3CqSJ","selectBlock":"template_selectBlock__39V_C","templates":"template_templates__GLWKu","notSelected":"template_notSelected__2FOmI"};